import React from 'react'
import { cn } from '@amusnet/react-ui'
import { useTranslation } from '@amusnet/translations/react'
import { ToggleButton } from '@components'
import UltraPlayBuyBonusDropdown from './UltraPlayBuyBonusDropdown'

// The "Stop on Feature" toggle + "Buy Bonus" dropdown rows. Rendered in two layout contexts:
//   - 'panel': the setup controls panel (responsive — stacks in landscape)
//   - 'band':  the portrait in-session settings band above the footer (fixed spacing)
type UltraPlayFeatureSettingsProps = {
    variant: 'panel' | 'band'
    isPortrait?: boolean
    isLandscape?: boolean
    stopOnFeature: boolean
    setStopOnFeature: (value: boolean) => void
    hasBuyBonus: boolean
    buyBonusFeatures: Array<{ name: string; label: string }>
    buyBonusValue: string
    onBuyBonusChange: (value: string) => void
}

const UltraPlayFeatureSettings: React.FC<UltraPlayFeatureSettingsProps> = ({
    variant,
    isPortrait,
    isLandscape,
    stopOnFeature,
    setStopOnFeature,
    hasBuyBonus,
    buyBonusFeatures,
    buyBonusValue,
    onBuyBonusChange,
}) => {
    const { t } = useTranslation()
    const isBand = variant === 'band'

    const stopRowClass = isBand
        ? 'flex items-center justify-between py-3'
        : cn(
              'flex items-center justify-between',
              isLandscape ? 'flex-col items-baseline mt-[12px] mb-[13px]' : 'py-3 mt-8 mb-[15px]'
          )

    const buyRowClass = isBand
        ? 'flex items-center justify-between py-3'
        : cn('flex items-center justify-between', isLandscape ? 'flex-col items-baseline' : 'py-3')

    const labelClass = isBand
        ? 'font-bold text-white text-[30px] leading-[36px]'
        : cn('font-bold text-white text-[30px] leading-[36px]', isLandscape && 'mb-2.5')

    return (
        <>
            <div className={stopRowClass}>
                <span className={labelClass}>{t('gameui.stopOnFeature')}</span>
                <ToggleButton isToggled={stopOnFeature} onClick={() => setStopOnFeature(!stopOnFeature)} />
            </div>

            {hasBuyBonus && buyBonusFeatures.length > 0 && (
                <div className={buyRowClass}>
                    <span className={labelClass}>Buy Bonus</span>
                    <UltraPlayBuyBonusDropdown
                        isPortrait={isPortrait}
                        isLandscape={isLandscape}
                        value={buyBonusValue}
                        onChange={onBuyBonusChange}
                        features={buyBonusFeatures}
                    />
                </div>
            )}
        </>
    )
}

export default UltraPlayFeatureSettings
